export default "__VITE_ASSET__BYTDCQtG__"